import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface CopilotState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const CopilotContext = createContext<CopilotState | null>(null);

export function CopilotStateProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <CopilotContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </CopilotContext.Provider>
  );
}

export function useCopilotState() {
  const ctx = useContext(CopilotContext);
  if (!ctx) throw new Error("useCopilotState must be used within CopilotStateProvider");
  return ctx;
}
